import React from 'react';
import { wrapFunctionalComponent } from 'utils/framework';
import ProductImage from 'components/Product/ProductImage';

function RecapImage({ sku, ...props }) {
    return (
        <ProductImage
            id={sku.skuId || sku?.currentSku?.skuId}
            skuImages={sku.skuImages}
            altText={`${sku.brandName} ${sku.productName || sku.displayName}`}
            hideBadge={true}
            {...props}
        />
    );
}

export default wrapFunctionalComponent(RecapImage, 'RecapImage');
